var React = require('react');

function IconCloseArea (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"16.5","cy":"16.5","r":"16.5","key":0}),React.createElement("g",{"stroke":"currentColor","key":1},[React.createElement("path",{"strokeLinecap":"square","d":"M23.571 9.429 9.43 23.57","key":0}),React.createElement("path",{"d":"M9.429 9.429 23.57 23.57","key":1})])]));
}

IconCloseArea.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33"};

module.exports = IconCloseArea;

IconCloseArea.default = IconCloseArea;
